import React, { useState } from "react";
import {
  FaUniversity,
  FaCalendarAlt,
  FaGraduationCap,
  FaChalkboardTeacher,
  FaArrowRight,
  FaFileAlt,
  FaAward,
  FaIndustry,
  FaClipboardList,
  FaGlobe,
  FaCheckCircle,
  FaChartLine,
  FaMoneyBillWave,
  FaPercent,
  FaExclamationTriangle,
} from "react-icons/fa";

const BPharmaSection = () => {
  const [activeTab, setActiveTab] = useState("career");

  const careerCategories = [
    {
      title: "Pharmaceutical Industry",
      icon: <FaIndustry className="text-2xl" />,
      careers: [
        "Production & Manufacturing",
        "Research & Development",
        "Quality Assurance / Quality Control",
        "Formulation Development",
        "Regulatory Affairs",
      ],
    },
    {
      title: "Clinical & Healthcare",
      icon: <FaClipboardList className="text-2xl" />,
      careers: [
        "Hospital Pharmacy",
        "Clinical Research",
        "Pharmacovigilance",
        "Community Pharmacy",
        "Drug Safety Associate",
      ],
    },
    {
      title: "Academics & Global",
      icon: <FaGlobe className="text-2xl" />,
      careers: [
        "Teaching & Research",
        "Higher Studies (M.Pharm, MBA, PhD)",
        "Opportunities Abroad",
        "Entrepreneurship",
        "Medical Writing",
      ],
    },
  ];
  const feeStructure = {
    total: "₹2,60,000",
    perYear: "₹65,000",
    installments: [
      {
        year: "1st Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "Before 1st Sem Exam", amount: "₹25,000" },
          { particular: "2nd Installment", time: "Before 2nd Sem Exam", amount: "₹25,000" },
        ],
      },
      {
        year: "2nd Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "Before 1st Sem Exam", amount: "₹25,000" },
          { particular: "2nd Installment", time: "Before 2nd Sem Exam", amount: "₹25,000" },
        ],
      },
      {
        year: "3rd Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "Before 1st Sem Exam", amount: "₹25,000" },
          { particular: "2nd Installment", time: "Before 2nd Sem Exam", amount: "₹25,000" },
        ],
      },
      {
        year: "4th Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "Before 1st Sem Exam", amount: "₹25,000" },
          { particular: "2nd Installment", time: "Before 2nd Sem Exam", amount: "₹25,000" },
        ],
      },
    ],
    notes: [
      "Excluding charges for Books, Uniform, Registration & Examination fees.",
      "Exam fee to be paid separately by students.",
      "Industrial Visit charges applicable.",
      "10% discount if total session fee paid in one go.",
      "10% discount for students with 85% or above in 12th.",
      "Late fee: ₹100/day for delayed payments.",
    ],
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-1.5 rounded-full text-sm font-medium mb-4">
            <FaAward className="text-sm" />
            <span>PCI Approved | AICTE Recognized</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-emerald-500 to-blue-600 bg-clip-text text-transparent">
            Bachelor of Pharmacy
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            A 4‑year professional program designed to build expertise in pharmaceutical sciences, with rigorous practical training and industry exposure.
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="p-8 md:p-10">
              <div className="flex flex-wrap justify-between items-start mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800">BACHELOR OF PHARMACY</h2>
                  <p className="text-gray-500 mt-1 flex items-center gap-2">
                    <FaGraduationCap className="text-blue-500" />
                    <span>Seats: 100 per year</span>
                  </p>
                </div>
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-5 py-2 rounded-full text-sm font-semibold shadow-md">
                  College Code: 883
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-gradient-to-br from-blue-50 to-white p-4 rounded-xl text-center shadow-sm border border-blue-100">
                  <div className="text-2xl font-bold text-blue-600">4 Years</div>
                  <div className="text-xs text-gray-500">Duration</div>
                </div>
                <div className="bg-gradient-to-br from-emerald-50 to-white p-4 rounded-xl text-center shadow-sm border border-emerald-100">
                  <div className="text-2xl font-bold text-emerald-600">8 Semesters</div>
                  <div className="text-xs text-gray-500">Course Structure</div>
                </div>
              </div>

              <div className="mb-8 space-y-3">
                <div className="flex items-center gap-3 text-gray-700">
                  <FaUniversity className="text-blue-500 text-lg" />
                  <span className="text-sm">
                    Affiliating University:{" "}
                    <strong>Dr. APJ Abdul Kalam Technical University, Lucknow</strong>
                  </span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <FaCalendarAlt className="text-emerald-500 text-lg" />
                  <span className="text-sm">
                    Course Structure: <strong>8 Semesters</strong> (Theory + Practicals) including Project Work and Industrial Exposure
                  </span>
                </div>
              </div>

              <div className="bg-gradient-to-r from-blue-50 to-emerald-50 p-5 rounded-xl mb-8 border-l-4 border-blue-500">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <h4 className="font-bold text-gray-800 flex items-center gap-2 mb-2">
                      <FaGraduationCap className="text-blue-600" /> Eligibility Criteria
                    </h4>
                    <p className="text-gray-700 text-sm">
                      10+2 with 50% in PCB/PCM
                      <br />
                      or
                      <br />
                      Diploma in Pharmacy with minimum 50% marks from any recognized Technical Board
                    </p>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 flex items-center gap-2 mb-2">
                      <FaChalkboardTeacher className="text-emerald-600" /> Lateral Entry
                    </h4>
                    <p className="text-gray-700 text-sm">D.Pharm with 60% marks (Direct entry to 2nd year)</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <button className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold text-sm hover:shadow-lg transition-all flex items-center gap-2">
                  Apply Now
                  <FaArrowRight />
                </button>
                <button className="px-6 py-3 border-2 border-gray-300 bg-white text-gray-700 rounded-xl font-semibold text-sm hover:bg-gray-50 transition-all flex items-center gap-2">
                  <FaFileAlt className="text-blue-500" />
                  Download Brochure
                </button>
              </div>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 md:p-8 border-t lg:border-t-0 lg:border-l border-gray-100">
              {/* Tab Headers */}
              <div className="flex gap-4 mb-6 border-b border-gray-200">
                <button
                  onClick={() => setActiveTab("career")}
                  className={`pb-2 px-2 font-semibold text-sm transition-colors ${
                    activeTab === "career"
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Career Opportunities
                </button>
                <button
                  onClick={() => setActiveTab("fee")}
                  className={`pb-2 px-2 font-semibold text-sm transition-colors ${
                    activeTab === "fee"
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Fee Structure
                </button>
              </div>
              {activeTab === "career" && (
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <FaChartLine className="text-emerald-600 text-xl" />
                    <h3 className="text-xl font-bold text-gray-800">Career in Pharmacy</h3>
                  </div>
                  <p className="text-gray-600 text-sm mb-6">
                    B.Pharm graduates have a wide range of career paths across industries, research, and academia.
                  </p>
                  <div className="space-y-6">
                    {careerCategories.map((cat, idx) => (
                      <div key={idx}>
                        <div className="flex items-center gap-2 mb-3">
                          <div className="p-1.5 bg-white rounded-full shadow-sm text-blue-500">
                            {cat.icon}
                          </div>
                          <h4 className="font-semibold text-gray-800 text-lg">{cat.title}</h4>
                        </div>
                        <div className="grid grid-cols-2 gap-2 ml-2">
                          {cat.careers.map((career, i) => (
                            <div key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                              <FaCheckCircle className="text-emerald-500 text-xs mt-0.5 flex-shrink-0" />
                              <span>{career}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-8 p-4 bg-blue-50/50 rounded-xl border border-blue-100">
                    <p className="text-xs text-gray-500">
                      * Higher studies options: M.Pharm, MBA, PhD, or PG Diploma in Clinical Research, etc.
                    </p>
                  </div>
                </div>
              )}
              {activeTab === "fee" && (
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <FaMoneyBillWave className="text-green-600 text-xl" />
                    <h3 className="text-xl font-bold text-gray-800">Fee Structure 2025-26</h3>
                  </div>
                  <div className="bg-white rounded-xl p-4 mb-4 shadow-sm border border-gray-100">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm font-semibold text-gray-700">Total Contract Fee:</span>
                      <span className="text-xl font-bold text-green-600">{feeStructure.total}</span>
                    </div>
                    <div className="text-sm text-gray-500 mb-4">(₹65,000 per year)</div>
                    {feeStructure.installments.map((yearData, idx) => (
                      <div key={idx} className="mb-5">
                        <h4 className="font-semibold text-gray-800 mb-2 text-sm">{yearData.year}</h4>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-xs">
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-2 py-1 text-left">Particulars</th>
                                <th className="px-2 py-1 text-left">Due Time</th>
                                <th className="px-2 py-1 text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {yearData.items.map((item, i) => (
                                <tr key={i} className="border-t border-gray-100">
                                  <td className="px-2 py-1">{item.particular}</td>
                                  <td className="px-2 py-1">{item.time}</td>
                                  <td className="px-2 py-1 text-right font-medium">{item.amount}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}

                    {/* Notes */}
                    <div className="mt-4 pt-3 border-t border-gray-200">
                      <div className="flex items-center gap-1 text-xs text-gray-500 mb-2">
                        <FaExclamationTriangle className="text-yellow-500" />
                        <span className="font-semibold">Important Notes:</span>
                      </div>
                      <ul className="text-xs text-gray-500 space-y-1 list-disc pl-4">
                        {feeStructure.notes.map((note, i) => (
                          <li key={i}>{note}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="flex justify-between items-center text-xs text-gray-500 mt-2 p-2 bg-green-50 rounded-lg">
                    <span>Discounts available</span>
                    <FaPercent className="text-green-600" />
                    <span>Up to 10%</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BPharmaSection;